export const mainServiceURL =
  import.meta.env.VITE_MAIN_SERVICE_URL ||
  import.meta.env.VITE_PROFILE_SERVICE_URL;

export const BSDataServiceURL = `${mainServiceURL}gateway/bs-data-service`;

export const gatewayURL = mainServiceURL + '/gateway';

export const ghostnewsPath = '/ghostnews-service';
export const ghostnewsServiceURL = gatewayURL + ghostnewsPath;

export const notificationsPath = '/notifications-service';
export const notificationsServiceURL = gatewayURL + notificationsPath;

export const filePath = '/file-service';
export const fileServiceURL = gatewayURL + filePath;

export const dataAnalyticsPath = '/data-analytics';
export const dataAnalyticsServiceURL = gatewayURL + dataAnalyticsPath;

export const cmsPath = '/cms-service';
export const cmsServiceURL = gatewayURL + cmsPath;
